import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openAutoUploadBuyDialog = () => openPopupHelper({ popupName: popupNames.AUTO_UPLOAD_BUY_DIALOG });
